import { Route } from '@angular/router';
import { AuthGuard } from '../guards/auth.guard';
import { RoleGuard } from '../guards/role.guard';

export const donorsRoutes: Route[] = [
  {
    path: 'donors-accounts/individuals-donors-list',
    loadComponent: () =>
      import(
        '../../features/donors/pages/individuals-donors-list/individuals-donors-list'
      ).then((mod) => mod.IndividualsDonorsList),
    pathMatch: 'full',
    canActivate: [AuthGuard, RoleGuard],
    data: {
      allowedRoles: ['superAdmin', 'supervisor'],
    },
  },
  {
    path: 'donors-accounts/corps-donors-list',
    loadComponent: () =>
      import(
        '../../features/donors/pages/corps-donors-list/corps-donors-list'
      ).then((mod) => mod.CorpsDonorsList),
    pathMatch: 'full',
    canActivate: [AuthGuard, RoleGuard],
    data: {
      allowedRoles: ['superAdmin', 'supervisor'],
    },
  },
  {
    path: 'donors-accounts/:donerId/doner-details',
    loadComponent: () =>
      import('../../features/donors/pages/doner-details/doner-details').then(
        (mod) => mod.DonerDetails
      ),
    pathMatch: 'full',
    canActivate: [AuthGuard, RoleGuard],
    data: {
      allowedRoles: ['superAdmin', 'supervisor'],
    },
  },
];
